"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.SelectableListItem = void 0;
var tslib_1 = require("tslib");
var react_1 = tslib_1.__importDefault(require("react"));
var styled_components_1 = tslib_1.__importDefault(require("styled-components"));
var ListItem_1 = tslib_1.__importDefault(require("@material-ui/core/ListItem"));
var transparency_1 = require("../../utils/theme/colors/transparency");
exports.SelectableListItem = function (_a) {
    var icon = _a.icon, _b = _a.label, label = _b === void 0 ? '' : _b, _c = _a.isSelected, isSelected = _c === void 0 ? false : _c, rest = tslib_1.__rest(_a, ["icon", "label", "isSelected"]);
    return (react_1.default.createElement(StyledListItem, tslib_1.__assign({}, rest, { selected: isSelected, disableGutters: true }),
        react_1.default.createElement(CheckIcon, { className: "icon--check", selected: isSelected }),
        icon && react_1.default.createElement(StyledIcon, { className: "icon--" + icon, selected: isSelected }),
        react_1.default.createElement("span", null, label)));
};
exports.SelectableListItem.displayName = 'FOS_SelectableListItem';
var StyledListItem = styled_components_1.default(function (_a) {
    var selected = _a.selected, rest = tslib_1.__rest(_a, ["selected"]);
    return (react_1.default.createElement(ListItem_1.default, tslib_1.__assign({}, rest)));
})(templateObject_1 || (templateObject_1 = tslib_1.__makeTemplateObject(["\n  && {\n    color: ", ";\n    font-family: ", ";\n    font-size: 1.3rem;\n    border: none;\n    margin-top: 0.1rem;\n    margin-bottom: 0.1rem;\n    width: 100%;\n    text-align: left;\n    line-height: 3.2rem;\n    padding: 0 3.2rem 0 0.8rem;\n    background-color: ", ";\n  }\n\n  &&:hover {\n    cursor: pointer;\n    background-color: ", ";\n  }\n\n  &&.Mui-disabled {\n    pointer-events: none;\n  }\n"], ["\n  && {\n    color: ", ";\n    font-family: ", ";\n    font-size: 1.3rem;\n    border: none;\n    margin-top: 0.1rem;\n    margin-bottom: 0.1rem;\n    width: 100%;\n    text-align: left;\n    line-height: 3.2rem;\n    padding: 0 3.2rem 0 0.8rem;\n    background-color: ",
    ";\n  }\n\n  &&:hover {\n    cursor: pointer;\n    background-color: ",
    ";\n  }\n\n  &&.Mui-disabled {\n    pointer-events: none;\n  }\n"])), function (_a) {
    var theme = _a.theme;
    return theme.colors.NTDarkGrey[900];
}, function (_a) {
    var theme = _a.theme;
    return theme.fonts.robotoRegular;
}, function (_a) {
    var theme = _a.theme, selected = _a.selected;
    return selected ? transparency_1.hexWithTransparency(theme.colors.aqua[200], 0.4) : '#ffffff';
}, function (_a) {
    var theme = _a.theme, selected = _a.selected;
    return !selected && theme.colors.NTDarkGrey[50];
});
var StyledIcon = styled_components_1.default(function (_a) {
    var selected = _a.selected, rest = tslib_1.__rest(_a, ["selected"]);
    return react_1.default.createElement("i", tslib_1.__assign({}, rest));
})(templateObject_2 || (templateObject_2 = tslib_1.__makeTemplateObject(["\n  margin-right: 0.5rem;\n  color: ", ";\n"], ["\n  margin-right: 0.5rem;\n  color: ", ";\n"])), function (_a) {
    var theme = _a.theme, selected = _a.selected;
    return selected && theme.colors.aqua[700];
});
var CheckIcon = styled_components_1.default(function (_a) {
    var selected = _a.selected, rest = tslib_1.__rest(_a, ["selected"]);
    return react_1.default.createElement("i", tslib_1.__assign({}, rest));
})(templateObject_3 || (templateObject_3 = tslib_1.__makeTemplateObject(["\n  visibility: ", ";\n  font-size: 1.4rem;\n  color: ", ";\n  margin-right: 0.5rem;\n"], ["\n  visibility: ", ";\n  font-size: 1.4rem;\n  color: ", ";\n  margin-right: 0.5rem;\n"])), function (_a) {
    var selected = _a.selected;
    return (selected ? 'visible' : 'hidden');
}, function (_a) {
    var theme = _a.theme;
    return theme.colors.aqua[700];
});
var templateObject_1, templateObject_2, templateObject_3;
